<template>
  <div style="margin-top: 15px" v-if="isMounted">
    <h4 class="text-center m-lg">
      For corporate with more than 10 users, unlimited usage, provisioning, collaboration, and advanced customization
    </h4>

    <carousel v-if="products" class="col-xs-10 col-xs-offset-1"
              :perPageCustom="[[0, 1], [800, 2], [1000, 2], [1400, 3], [2000, 5]]"
              :perPage="5" :navigationEnabled="true" :loop="true" :autoplay="true">
      <template v-for="(product, key) in products"  v-if="products.length && product && product.description">
        <slide class="" :key="key" :data-index="key" style="padding: 0 15px">
          <div class="hpanel hblue" >
            <div class="panel-heading hbuilt text-center">
              <h4 class="font-bold">
                <span v-if="$auth.user().profile.id !== 1 && $auth.user().role_name === product.role && $auth.user().plan.plan_id === product.planId" class="label label-info">Current</span>
                {{product.name}}
              </h4>
              <div class="text-center">
                <a class="btn btn-info btn-sm m-t-xs btn-block" target="_blank" href="https://www.idexlab.com/contact-us/  ">Contact us</a>
              </div>
            </div>
            <div class="panel-body ">
                <template v-if="product.search">
                  <table class="table">
                    <thead>
                    <tr>
                      <td width="60%">
                        <h5>Search</h5>
                      </td>
                      <td width="40%" class="text-center">
                      </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(key, search) in product.search" :key="search + key" style="font-size: 12px">
                      <td>
                        {{search}}
                      </td>
                      <td class="text-center">
                        {{key}}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </template>

                <template v-if="product.other">

                  <table class="table">
                    <thead>
                    <tr>
                      <td width="60%">
                      </td>
                      <td width="40%">
                      </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(key, feature) in product.other" :key="feature + key" style="font-size: 12px">
                      <td>
                        {{feature}}
                      </td>
                      <td class="text-center">
                        {{key}}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </template>
              <template v-if="product.customisation">

                <table class="table">
                  <thead>
                  <tr>
                    <td width="60%">
                      <h5>Customisation</h5>
                    </td>
                    <td width="40%">
                    </td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(key, feature) in product.customisation" :key="feature + key" style="font-size: 12px">
                    <td>
                      {{feature}}
                    </td>
                    <td class="text-center">
                      {{key}}
                    </td>
                  </tr>
                  </tbody>
                </table>
              </template>
              <div class="text-center">
                <a class="btn btn-info btn-sm m-t-xs btn-block" target="_blank" href="https://www.idexlab.com/contact-us/  ">Contact us</a>
              </div>
            </div>
          </div>
        </slide>
      </template>
    </carousel>
  </div>

</template>

<style>
  .VueCarousel-dot-container {
    margin-top: 0 !important;
  }
</style>
<script>

import { Carousel, Slide } from 'vue-carousel'
import VueLadda from 'vue-ladda'

export default {
  components: {Carousel, Slide, VueLadda},
  name: 'ProductSelectionCorporate',
  data () {
    return {
      isMounted: false,
      products: [{
        name: 'Corporate Seeker',
        description: 'Description Corporate Seeker',
        search: {'Science': 'unlimited', 'Patents': 'unlimited', 'Companies': 'unlimited'},
        other: {'Workflows': 'All',
          'Projects storage': 'unlimited',
          'Open Innov. Campaign': '-',
          'Account provisioning': '-',
          'Team': 'stats, collaboration',
          'On boarding': 'Custom training',
          'Support': 'Dedicated'
        },
        customisation: {'logo': 'Yes', 'url': 'Yes', 'preferred sources': 'Yes', 'specific sources / workflows': 'Yes', 'SSO': 'Yes', 'IP filtering': 'Yes', 'Anonymous emails': '-'},
        role: 'Seeker',
        planId: 5
      }, {
        name: 'Corporate Broker',
        description: 'Description Corporate Broker',
        search: {'Science': 'unlimited', 'Patents': 'unlimited', 'Companies': 'unlimited'},
        other: {
          'Workflows': 'All',
          'Projects storage': 'unlimited',
          'Open Innov. Campaign': 'unlimited',
          'Account provisioning': 'Yes',
          'Team': 'stats, collaboration',
          'On boarding': 'Custom training',
          'Support': 'Dedicated'
        },
        customisation: {'logo': 'Yes', 'url': 'Yes', 'preferred sources': 'Yes', 'specific sources / workflows': 'Yes', 'SSO': 'Yes', 'IP filtering': 'Yes', 'Anonymous emails': 'Yes'},
        role: 'Broker',
        planId: 5
      }, {
        name: 'Corporate Manager',
        description: 'Description Corporate Manager',
        search: {'Science': 'unlimited', 'Patents': 'unlimited', 'Companies': 'unlimited'},
        other: {'Workflows': 'All',
          'Projects storage': 'unlimited',
          'Open Innov. Campaign': 'unlimited',
          'Account provisioning': 'Yes',
          'Team': 'company wide stats, collaboration',
          'On boarding': 'Custom training',
          'Support': 'Dedicated'
        },
        customisation: {'logo': 'Yes', 'url': 'Yes', 'preferred sources': 'Yes', 'specific sources / workflows': 'Yes', 'SSO': 'Yes', 'IP filtering': 'Yes', 'Anonymous emails': 'Yes'},

        role: 'Manager',
        planId: 5
      }],
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      }
    }
  },
  mounted () {
    let products = Object.assign([], this.products)

    this.products = []

    setTimeout(() => {
      this.isMounted = true
      this.products = products
    }, 500)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/plan/ProductSelectionCorporate.vue